import { AutogenLayoutTrackingRequirements } from "./autogen/AutogenLayoutTrackingRequirements";
import {ChangeEvent, DataDisplayEvent} from "@mcleod/components";
import {StringUtil} from "@mcleod/core";

export class TrackingRequirements extends AutogenLayoutTrackingRequirements {

    private readonly MACROPOINT_VENDOR = "M";

    textboxRequiredVendorBeforeLookupModelSearch(event) {
        event.filter.is_active = true;
    }

    textboxRequiredVendorOnChange(event: ChangeEvent){
        if(event.userInitiatedChange){
            this.textboxGeoOverrideMins.visible = StringUtil.equalsIgnoreCase("MacroPoint", event.newValue);
        }
    }

    textboxRequiredVendorOnDataDisplay(event: DataDisplayEvent){
        this.textboxGeoOverrideMins.visible = StringUtil.equalsIgnoreCase(event.rowData?.get("required_vendor"),this.MACROPOINT_VENDOR);
    }


}
